// ./ui/RegretWheel.js
import React, { useEffect, useRef } from "react";
import { motion, useAnimation } from "framer-motion";

const segments = [
  "10k $REGRET", "50k $REGRET", "100k $REGRET", "250k $REGRET", "500k $REGRET",
  "Free Spin 🎉", "Double Prize 🔁", "You Lose ❌", "Mystery 🪄", "Regret Mirror 🪞",
  "Tax the wallet 💸", "JACKPOT 💎"
];

const segmentAngle = 360 / segments.length;

function getCoordinatesForAngle(angle, radius) {
  const rad = (angle - 90) * (Math.PI / 180);
  return {
    x: radius + radius * Math.cos(rad),
    y: radius + radius * Math.sin(rad),
  };
}

export default function RegretWheel({ spinning, targetIndex, onSpinComplete }) {
  const controls = useAnimation();
  const baseRotation = useRef(0);

  useEffect(() => {
    if (!spinning || targetIndex == null) return;

    const pointerAngle = 270; // 12 uur
    const segmentCenterAngle = (targetIndex + 0.5) * segmentAngle;
const correction = (pointerAngle - segmentCenterAngle + 360 + 90) % 360;

    const fullRotations = 6;
    const totalRotation = 360 * fullRotations + correction;

    baseRotation.current = totalRotation % 360;

    controls.set({ rotate: 0 }); // reset voor consistente spins
    controls.start({
      rotate: totalRotation,
      transition: {
        duration: 3,
        ease: [0.1, 0.8, 0.3, 1],
      },
    }).then(() => {
      onSpinComplete(targetIndex);
    });
  }, [spinning, targetIndex]);

  const radius = 160;
  const viewBoxSize = radius * 2;

  return (
    <div className="relative my-6">
      {/* Pointer op 12 uur */}
      <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[10px] border-r-[10px] border-t-[20px] border-l-transparent border-r-transparent border-t-cyan-400 z-10" />
      
      <motion.svg
        width={viewBoxSize}
        height={viewBoxSize}
        viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
        animate={controls}
        initial={{ rotate: 0 }}
        className="rounded-full shadow-[0_0_20px_#0ff4]"
      >
        {segments.map((label, i) => {
          const startAngle = i * segmentAngle;
          const endAngle = startAngle + segmentAngle;
          const largeArc = segmentAngle > 180 ? 1 : 0;

          const start = getCoordinatesForAngle(startAngle, radius);
          const end = getCoordinatesForAngle(endAngle, radius);

          const pathData = `
            M ${radius} ${radius}
            L ${start.x} ${start.y}
            A ${radius} ${radius} 0 ${largeArc} 1 ${end.x} ${end.y}
            Z
          `;

          const fill = i % 2 === 0 ? "#0ff4" : "#1f2937";
          const textColor = i % 2 === 0 ? "#000000" : "#00FFFF";

          const midAngle = startAngle + segmentAngle / 2;
          const textRadius = radius * 0.9;
          const textX = radius + textRadius * Math.cos((midAngle - 90) * (Math.PI / 180));
          const textY = radius + textRadius * Math.sin((midAngle - 90) * (Math.PI / 180));

          return (
            <g key={i}>
              <path d={pathData} fill={fill} />
              <text
                x={textX}
                y={textY}
                fill={textColor}
                fontSize="10"
                fontWeight="bold"
                textAnchor="middle"
                alignmentBaseline="middle"
                transform={`rotate(${midAngle}, ${textX}, ${textY})`}
              >
                {label}
              </text>
            </g>
          );
        })}
      </motion.svg>
    </div>
  );
}
